import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import mapReducer from "../features/map/mapSlice";
import { mapGateMiddleware } from "../account/mapGateMiddleware";

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    map: mapReducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(mapGateMiddleware),
});
